import { render, staticRenderFns } from "./payrollHolidays.vue?vue&type=template&id=40a6f43f"
import script from "./payrollHolidays.vue?vue&type=script&lang=js"
export * from "./payrollHolidays.vue?vue&type=script&lang=js"
import style0 from "./payrollHolidays.vue?vue&type=style&index=0&id=40a6f43f&prod&lang=css"
import style1 from "./payrollHolidays.vue?vue&type=style&index=1&id=40a6f43f&prod&slot-scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports